import SellerProductTableRow from "./SellerProductTableRow";

function SellerProductTable({ products, onRefresh }) {
      const finalProducts = products.data.products;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto border border-gray-200">
        <thead className="bg-gray-100 text-left text-sm font-semibold text-gray-700">
          <tr>
            <th className="p-3">Image</th>
            <th className="p-3">Name</th>
            <th className="p-3">Brand</th>
            <th className="p-3">Price</th>
            <th className="p-3">Stock</th>
            <th className="p-3">Category ID</th>
            <th className="p-3">SKU</th>
            <th className="p-3">Slug</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {finalProducts.map(product => (
            <SellerProductTableRow key={product.id} product={product} onRefresh={onRefresh} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SellerProductTable;
